package app.nestbridge.feature.profile.presentation

import app.nestbridge.feature.profile.screen.CreateUserProfileScreen
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
@Origin(CreateUserProfilePresenter::class)
public class CreateUserProfilePresenterFactory(
  private val factory:
      (screen: CreateUserProfileScreen, navigator: Navigator) -> CreateUserProfilePresenter,
) : Presenter.Factory {
  override fun create(
    screen: Screen,
    navigator: Navigator,
    context: CircuitContext,
  ): Presenter<*>? = when (screen) {
    is CreateUserProfileScreen -> factory(screen, navigator)
    else -> null
  }
}
